@if (requsitionNumber) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img
        class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()"
        />
      </div>
      <div class="dialogContent">
        <app-dialog-input-title title="Kunde"></app-dialog-input-title>
        <select
          [(ngModel)]="selectedCustomer"
          (ngModelChange)="updateProjectList()"
          >
          <option value="0" class="hidden">Vælg kunde</option>
          @for (customer of customers; track customer) {
            <option [value]="customer.id">
              {{ customer.name }}
            </option>
          }
        </select>
        <app-dialog-input-title
          title="Projekt"
          [required]="true"
        ></app-dialog-input-title>
        <select
          [(ngModel)]="requsitionNumber.projectId"
          (ngModelChange)="updateCustomer()"
          >
          <option value="0" class="hidden">Vælg projekt</option>
          @for (project of filteretProjects; track project) {
            <option [value]="project.id">
              {{ project.name }}
            </option>
          }
        </select>
        <app-dialog-input-title
          title="Rekvisitions status"
          [required]="true"
        ></app-dialog-input-title>
        <select [(ngModel)]="requsitionNumber.requisitionStatus">
          @for (reqStatus of requisitionStatus; track reqStatus) {
            <option [value]="reqStatus">
              {{ requisitionStatusTranslations[reqStatus] }}
            </option>
          }
        </select>
        <app-dialog-input-title
          title="Rekvisitions nummer"
          [required]="true"
        ></app-dialog-input-title>
        <input type="text" [(ngModel)]="requsitionNumber.reqNumber" />
        <app-dialog-input-title
          title="Dato"
          [required]="true"
        ></app-dialog-input-title>
        <input type="date" [(ngModel)]="reqDate" />
        <app-dialog-input-title
          title="Opgave beskrivelse"
          [required]="true"
        ></app-dialog-input-title>
        <textarea class="textarea" [(ngModel)]="requsitionNumber.taskDescription">
        </textarea>
        <app-dialog-input-title
          title="Opgave status"
          [required]="true"
        ></app-dialog-input-title>
        <select [(ngModel)]="requsitionNumber.requisitionTaskStatus">
          <option value="0" class="hidden">Vælg projekt</option>
          @for (taskStatus of requisitionTaskStatus; track taskStatus) {
            <option
              [value]="taskStatus"
              >
              {{ requisitionTaskStatusTranslations[taskStatus] }}
            </option>
          }
        </select>
        <app-dialog-input-title title="Opgave ansvarlig"></app-dialog-input-title>
        <select [(ngModel)]="requsitionNumber.userId">
          <option value="0">Evt vælg opgave ansvarlig</option>
          @for (user of users; track user) {
            <option [value]="user.id">
              {{ user.name }}
            </option>
          }
        </select>
        <app-dialog-input-title title="Kommentar"></app-dialog-input-title>
        <textarea class="textarea" [(ngModel)]="requsitionNumber.comment">
        </textarea>
      </div>
      <div class="dialogFooter">
        <app-save-button
      [disabled]="
        requsitionNumber.projectId == 0 ||
        requsitionNumber.reqNumber == '' ||
        requsitionNumber.taskDescription == '' ||
        reqDate == ''
      "
          [clickEvent]="saveChanges.bind(this)"
          >
        </app-save-button>
        @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
          <app-delete-button
            [clickEvent]="deleteRequisitionNumber.bind(this)"
            >
          </app-delete-button>
        }
      </div>
    </div>
  }
